import React, { useEffect, useState } from "react";
import axios from "axios";
import { config, IMAGE_URL, projectname, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS
import styles from "./styles.css";
import { format } from 'date-fns';
import { purple } from "@material-ui/core/colors";
import LOADER from "../../assets/img/barakahhijama.gif";

function TimeSlogList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [tags, setTags] = useState([]);
  const [loading, setloading] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedDate, setSelectedDate] = useState([]);
  const currentDate = new Date();
  const [error, setError] = useState(null);
  const con = {
    headers: {
      ContentType: 'application/json',
      Authorization: "Bearer " + localStorage.getItem("njrujBf847hAfkxncmRbjfhy37AdyhbcKn84hdA8hggeras"),
    },
  };
  useEffect(() => {
    getTimeSlots();
  }, []);

  const getTimeSlots = async () => {
    try {
      axios.get(URL_API + "auth/admin/timeslot", con).then((response) => {
        if (response?.data?.status === 200) {
          setTags(response?.data?.timeslots);
          setloading(false)

        }
      });
    } catch (error) {
      setError(error.message);
    } finally {
    }

  };

  const destroyTag = (id) => {
    axios
      .post(URL_API + `auth/admin/category-delete/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/categories");
          toast.success("Category Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getTimeSlots();
        }
      });
  };




  const handleChange = (date) => {
    // Check if the date is already selected
    if (selectedDate.find((d) => d?.getTime() === date?.getTime())) {
      // If selected, filter it out (remove)
      setSelectedDate(selectedDate.filter((d) => d?.getTime() !== date?.getTime()));
    } else {
      // If not selected, add it to the array
      setSelectedDate([...selectedDate, date]);
    }
    // Set selected prop to null to avoid default selection behavior
    // and let highlightDates handle the visual selection
    // Note: You might need to add specific CSS for the highlightDates class
  };




  const onAddTimeSlotSubmit = (event) => {
    event.preventDefault();

    let formData = new FormData();
    const formattedDate = selectedDate?.map(date => format(date, 'yyyy-MM-dd'));
    // const arraysadf = formattedDate.split(',')

    formData.append('date', formattedDate)

    axios
      .post(URL_API + "auth/admin/timeslot", formData, con)
      .then((response) => {
        console.log('hehehehe', response)
        if (response.status == 200) {
          // history.push("/admin/tags");/
          getTimeSlots();
          toast.success("Time Slots Added Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setShow(false)
          setSelectedDate([])

          // setName("");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const uniqueItems = [...new Set(tags?.map(item => item?.date))].map(date => {
    return tags?.find(item => item?.date === date);
  });
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  {projectname} | <i class="fa fa-home" aria-hidden="true"></i> |
                  Time Slots
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <a >
                  <strong onClick={() => setShow(true)}>Add TimeSLot + </strong>
                </a>
              </div>
              <CardBody>
                <Table responsive>


                  <tbody>
                    {loading == true ? (
                      <>
                        <div className="loader">
                          <img src={LOADER} />
                        </div>
                      </>

                    ) : error ? (
                      <div className="error">Error: {error}</div>
                    ) : (
                      <>
                        {uniqueItems?.map(
                          (slot, index) => {
                            return (
                              <>
                                <tr className="color-theme" >
                                  <td colSpan={3} className="td-style">{moment(slot?.date).format(" DD MMMM, YYYY")}</td>
                                </tr>
                                <tr className="text-center-line-heading">
                                  <th>Time</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                                {tags?.map((ts) => {
                                  return <>
                                    {ts?.date == slot?.date ?
                                      <>
                                        <tr className="text-center-line" style={{ fontSize: '50px !important' }}>
                                          <td >{moment(ts?.start_time, "HH:mm").format("h:mm A")}</td>
                                          <td>{ts?.status}</td>
                                          <td>
                                            <Link to={`timeslot/edit/${ts.id}`}>
                                              <i class="far fa-edit fa-lg"></i>
                                            </Link>
                                            {/* &nbsp;&nbsp;&nbsp;&nbsp;
                                        <a
                                          style={{ color: "red" }}
                                          onClick={() => destroyTag(ts.id)}
                                        >
                                          <i class="fas fa-trash-alt fa-lg"></i>
                                        </a> */}
                                          </td>
                                        </tr>
                                      </>
                                      :
                                      ''
                                    }
                                  </>
                                })}
                              </>


                            );
                          }
                          // )
                        )}
                      </>
                    )}



                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>



        <Modal
          show={show}
          onHide={handleClose}
        >
          <Modal.Header>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <b style={{ color: "#000" }} >Add Time Slot</b>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <div className="times-fa" onClick={() => setShow(false)}><i className="fa fa-times"></i></div>
            </div>

          </Modal.Header>
          {/* <form> */}
          <form onSubmit={(e) => onAddTimeSlotSubmit(e)}>
            <div className={`container-fluid`}>
              <div className={styles.HeroiImgBlogForm}></div>
              <div className="container">
                <div className={`form ${styles.blogPostForm}`}>
                  <div className="form-group">
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                      <div htmlFor="form-group" className={styles.labelPostForm} style={{ textAlign: 'center' }}>
                        <DatePicker
                          selected={null}
                          onChange={handleChange}
                          dateFormat="yyyy-MM-dd" // Display format for the user
                          minDate={currentDate} // Set the minimum selectable date to today
                          popperClassName="example-datepicker-class"
                          showIcon={true}
                          highlightDates={selectedDate} // Use highlightDates to mark selected days
                          inline
                        />

                      </div>
                      <div className="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                        <div className="btn btn-reset" onClick={() => setSelectedDate([])}>Reset Date</div>
                      </div>
                    </div>


                  </div>


                  <Input
                    type="submit"
                    name="submit"
                    className="btn btn-danger"
                    value="Submit"
                  />
                </div>
                <br />
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
}

export default TimeSlogList;
